import React from "react";

import JobPage from "./JobPage";

const SolidityEngineer = () => (
    <JobPage
        title="Software Engineer, Solidity / Web3"
        location="Malta"
        summary={[
            "Develop in Go and React using best practices.",
            "Write clean code with unit tests.",
            "Work closely with the product development team to deliver on assigned tasks.",
            "Raise issues encountered during development with peers and stakeholders.",
            "Work in an agile environment and provide progress reports through sprint and scrum principles.",
            "Collaborate with fellow developers to deliver the best possible design and solution.",
            "Coordinate with other departments to remove blockers.",
        ]}
        tldrIntro="Don't read this unless you know"
        tldr={[
            "You have a proven track record of shipping high-quality code on time.",
            "You eat and breathe great user experiences.",
            "You enjoy moving across the stack, frontend and backend.",
            "You've built financial-services applications with Go. Bonus points for Java, Python, Ruby, etc.",
            "You have a deep understanding of microservices architectures, and you've built web apps with React, Angular, or Vue. Did we mention React?",
            "You know a thing or two about DeFi applications.",
        ]}
        requirements={[
            "5+ years' experience designing and developing Web3 solutions, preferably in payment processing & financial transactions.",
            "BS or higher in Computer Science or related discipline (or equivalent experience).",
            "Experience in banking, payment processing, forex, brokerage services, and/or crypto.",
            "Proven track record of delivering on time, to specification.",
            "Experience with Agile methodologies and DevOps.",
            "Self-starter with a can-do attitude.",
            "Comfortable evaluating new technologies and weighing tradeoffs to make sound decisions.",
        ]}
        experienceNeeded={["Solidity and Web3 experience.", "Go experience."]}
        desiredExperience={[
            "Strong knowledge of HTTP, REST APIs, and designing web services / microservices.",
            "JavaScript framework experience (React, Vue, Angular).",
            "Financial services, brokerage, or crypto background.",
            "SEPA / ACH / NPP / PSD2 experience. eKYC, remote onboarding, and remote enrollment a plus.",
        ]}
    />
);

export default SolidityEngineer;
